module.exports = __webpack_public_path__ + "img/a36.e0fd507b.svg";